/**
 * Filters the list of possible months based on a given starting year and a maximum allowed date.
 *
 * @param {number|string} startingFromYear - The starting year to compare against the max date's year.
 * @param {Array<{ value: string, label: string }>} monthsOptions - The list of month options, each containing a value and label.
 * @param {{ year: string, month: string }} maxDate - The maximum allowed date with a `year` and `month` (as a string).
 * @returns {Array<{ value: string, label: string }>} The filtered list of month options.
 */
const getPossibleMonths = (startingFromYear, monthsOptions, maxDate) => {
  if (+startingFromYear < +maxDate.year) {
    return monthsOptions;
  }

  return monthsOptions.filter(({ value }) => +value <= +maxDate.month);
};

export default getPossibleMonths;
